import { Box } from 'apollo-react';
import Loader from 'apollo-react/components/Loader';
import Switch from 'apollo-react/components/Switch';
import Tooltip from 'apollo-react/components/Tooltip';
import Typography from 'apollo-react/components/Typography';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { setArchiveWarningShown } from '../../actions/AuthActions';
import { handleErrors } from '../../actions/ErrorActions';
import { addWarning } from '../../actions/WarningActions';
import { toggleArchiveMode } from '../../api/archived-mode';
import * as Urls from '../../constants/Urls';
import { WARNING_SOURCES } from '../../constants/WarningsConstants';
import { useTranslation } from '../../custom-hooks/useTranslation';
import { getIsSystemTranslationLoaded } from '../../form-designer/selectors/common.selectors';
import { getUITA } from '../../utils/commonUtils';

export const ArchiveModeSwitcher = () => {
  const dispatch = useDispatch();
  const translateString = useTranslation();
  const history = useHistory();
  const { pathname } = useLocation();

  const [checked, setChecked] = useState(false);
  const [isLoading, setLoading] = useState(false);

  const { isArchiveMode, isArchiveWarningAlreadyShown } = useSelector((state) => state.auth);
  const isSystemTranslationLoaded = useSelector(getIsSystemTranslationLoaded);

  useEffect(() => {
    if (isArchiveMode && isSystemTranslationLoaded && !isArchiveWarningAlreadyShown) {
      dispatch(setArchiveWarningShown());
      dispatch(
        addWarning({
          message: translateString('Archive Mode has been activated.'),
          source: WARNING_SOURCES.ARCHIVE_MODE,
        })
      );
    }
  }, [
    isArchiveWarningAlreadyShown,
    isSystemTranslationLoaded,
    isArchiveMode,
    dispatch,
    translateString,
  ]);

  const handleArchivedModeSwitch = async () => {
    setLoading(true);
    const response = await toggleArchiveMode(!isArchiveMode);

    if (response.hasError) {
      dispatch(handleErrors(response.errors));
      setLoading(false);
      return;
    }

    const { Token } = response;
    setChecked(!checked);
    localStorage.setItem('token', Token);
    localStorage.setItem('isArchiveMode', !isArchiveMode);

    if (pathname !== Urls.HOME) {
      history.push(Urls.HOME);
    }

    setLoading(false);
    window.location.reload();
  };

  return (
    <Box display="flex" alignItems="center" gap={1} ui-ta={getUITA('ArchiveModeSwitcher')}>
      <Typography color="white">{translateString('Archive Mode')}</Typography>
      <Tooltip title={translateString('Archive Mode')} placement="bottom">
        <Switch
          size="small"
          checked={checked || isArchiveMode}
          onChange={handleArchivedModeSwitch}
          aria-label={translateString('Archive Mode')}
        />
      </Tooltip>
      {isLoading && <Loader />}
    </Box>
  );
};
